import React from 'react';
import MonacoEditor from 'react-monaco-editor';

const ConfigurationEditor = ({ settings, isSuperUser, onChange, data }) => {
  if (!isSuperUser) {
    return <div> not allowed </div>;
  }

  const handleChange = (newvalue) => {
    onChange({ ...settings, configuration: newvalue });
  };

  const options = {
    selectOnLineNumbers: true,
    colorDecorators: true
  };

  return (
    <div className='flex flex-1' style={{ height: '80vh' }}>
      <MonacoEditor language='json' theme='vs-dark' onChange={handleChange} options={options} defaultValue={JSON.stringify(JSON.parse(data.settings.configuration), null, 2)} />
    </div>
  );
};

export default ConfigurationEditor;
